export const commonAcceptFileTypes = {
  accept: 'image/png, image/jpg, image/jpeg, image/bmp, application/pdf',
  readableFileTypes: ['PNG', 'JPG', 'JPEG', 'BMP', 'PDF'],
};
